import React from 'react';
import Skeleton from 'react-loading-skeleton';

export default function PageLoader() {
    return (
        <div className="w-full p-4 sm:p-6 space-y-3.5" style={{ background: 'var(--color-bg)' }}>
            {/* ── Page Header Skeleton ── */}
            <div
                className="w-full rounded-xl border p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 shadow-card"
                style={{
                    backgroundColor: 'var(--color-card, #FFFFFF)',
                    borderColor: 'var(--color-border, #E2E8F0)',
                }}
            >
                <div className="flex items-center gap-3.5">
                    <Skeleton width={44} height={44} borderRadius={12} />
                    <div className="space-y-1.5">
                        <Skeleton width={70} height={14} borderRadius={4} />
                        <Skeleton width={180} height={20} borderRadius={6} />
                        <Skeleton width={260} height={12} borderRadius={4} />
                    </div>
                </div>
                <Skeleton width={120} height={36} borderRadius={8} />
            </div>

            {/* ── KPI Stat Cards Skeleton ── */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {Array.from({ length: 3 }).map((_, i) => (
                    <div
                        key={i}
                        className="rounded-xl border p-4 shadow-card"
                        style={{
                            backgroundColor: 'var(--color-card, #FFFFFF)',
                            borderColor: 'var(--color-border, #E2E8F0)',
                        }}
                    >
                        <Skeleton width={90} height={12} className="mb-2" />
                        <Skeleton width={60} height={24} borderRadius={6} />
                    </div>
                ))}
            </div>

            {/* ── Filter Toolbar Skeleton ── */}
            <div
                className="rounded-xl border p-3 sm:p-3.5 flex flex-wrap items-center justify-between gap-2.5 shadow-card"
                style={{
                    backgroundColor: 'var(--color-card, #FFFFFF)',
                    borderColor: 'var(--color-border, #E2E8F0)',
                }}
            >
                <Skeleton width={240} height={36} borderRadius={8} />
                <Skeleton width={100} height={36} borderRadius={8} />
            </div>

            {/* ── Table Card Skeleton ── */}
            <div
                className="w-full rounded-xl shadow-card border overflow-hidden"
                style={{
                    backgroundColor: 'var(--color-card, #FFFFFF)',
                    borderColor: 'var(--color-border, #E2E8F0)',
                }}
            >
                <table className="w-full border-collapse">
                    <thead>
                        <tr style={{ borderBottom: '2px solid var(--color-border)', backgroundColor: 'var(--color-control)' }}>
                            {Array.from({ length: 6 }).map((_, i) => (
                                <th key={i} style={{ padding: '12px 16px', textAlign: 'left' }}>
                                    <Skeleton width={i === 0 ? 50 : '75%'} height={12} />
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: 7 }).map((_, rowIdx) => (
                            <tr
                                key={rowIdx}
                                style={{
                                    borderBottom: '1px solid var(--color-border)',
                                    backgroundColor: rowIdx % 2 === 0 ? 'var(--color-card)' : 'var(--color-primary-light)',
                                }}
                            >
                                {Array.from({ length: 6 }).map((_, colIdx) => (
                                    <td key={colIdx} style={{ padding: '12px 16px' }}>
                                        <Skeleton
                                            height={14}
                                            width={colIdx === 0 ? 50 : `${50 + (colIdx * 11) % 40}%`}
                                            borderRadius={4}
                                        />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
